import { useCustomSnackbar } from '@amagimedia/amagi-design-system';
import { Typography } from '@amagimedia/amagi-design-system/src/Typography/Typography';
import {
  ACCESS_TOKEN_PART_1_KEY,
  ACCESS_TOKEN_PART_2_KEY,
  ACCESS_TOKEN_PART_3_KEY,
  REFRESH_TOKEN_KEY,
} from '@amagimedia/api-client/src/constants';
import { APP_BASE_DOMAIN } from '@amagimedia/commons';
import { deleteStvV2Token } from '@amagimedia/commons/src/apis/auth-stv-v2';
import { getAxiosErrorMessageAsString } from '@amagimedia/commons/src/utils';
import { useEffect, type FC } from 'react';
import { useHistory } from 'react-router-dom';
import { HomeScreenContainer } from './HomeScreenContainer';
import { deleteMultipleCookies } from './SigningIn';

export function useAuthCode() {
  const {
    location: { search },
  } = useHistory();
  const searchParams = new URLSearchParams(search);
  return searchParams.get('code') || '';
}

export const SigningOut: FC = () => {
  const { push } = useHistory();
  const showSnackbar = useCustomSnackbar();

  useEffect(() => {
    deleteStvV2Token()
      .then(() => {
        let domain = '';

        if (APP_BASE_DOMAIN) {
          domain = APP_BASE_DOMAIN;
        }
        deleteMultipleCookies(
          [
            ACCESS_TOKEN_PART_1_KEY,
            ACCESS_TOKEN_PART_2_KEY,
            ACCESS_TOKEN_PART_3_KEY,
            REFRESH_TOKEN_KEY,
          ],
          `.${domain}`,
        );
        window.location.assign(`https://${domain}/signin`);
        return;
      })
      .catch((e) => {
        showSnackbar(getAxiosErrorMessageAsString(e), 'error');
      });
  }, [showSnackbar, push]);

  return (
    <HomeScreenContainer>
      <Typography type="headingH1">Logging out...</Typography>
    </HomeScreenContainer>
  );
};
